<template>
    <div class="detail-content" ref="middle_page">
      <div class="primarylists list-mobile left-0">
        <div class="titles clear">
          <img src="../../../static/images/icon-st.jpg"/>
          <div class="title l" style="text-transform: uppercase!important;">{{$t('scoreStatistics.performanceAnalysis')}}</div>
        </div>
      </div>
        <div class="exam_begins_box ">
          <!-- Search -->
          <div class="exam_begins_rule">
            <el-form :model="form">
              <el-form-item label class="font_col">
                <el-row class="div-s-ch">
                  <el-col class="div-s-l">
                    <el-input :placeholder="$t('scoreStatistics.courseNameInput')" maxlength="150" v-model="keyword" clearable @keyup.enter.native="search_s()">
                      <template slot="prepend">{{$t('scoreStatistics.courseName')}}</template>
                    </el-input>
                    <el-button class="btn-s-n" @click="search_s">{{$t('scoreStatistics.search')}}</el-button>
                  </el-col>
                  <el-col class="div-ch showCompletedCourseCheck">
                    <span class="menu-switch-school lesson_begin" :value="checked" :class="{ 'menu-switch-school-on': checked }" @click="checkedCallBack()"></span>
                    <span @click="checkedCallBack()" class="showCompletedCourseCheckText">{{$t('new.showCompletedCourse')}}</span>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>
          <!-- Table PC -->
          <div class="course_box course_box_pc">
            <div class="exam_begins_rule_content" v-if="this.datatablelist.length > 0">
              <el-table :data="pagedDatatablelist" :empty-text="$t('js.dataNone')" @header-click="sortTable" :header-cell-style="tableHeaderStyle">
                <el-table-column prop="no" fixed type="index" :label="$t('courseList.no')" header-align="center" align="center" width="50px">
                  <template slot-scope="scope">{{(page - 1) * limit + scope.$index + 1}}</template>
                </el-table-column>
                <el-table-column prop="courseName" :render-header="icons" fixed width="240px" show-overflow-tooltip :label="$t('scoreStatistics.courseName')" header-align="center" align="left">
                  <template slot-scope="scope">
                    <img v-if="scope.row.judge == '1'" src="../../../static/images/baihoc-xanhla.png" class="curriculum_img" @click="goto_Aicourse(scope.row.courseId)"/>
                    <img v-if="scope.row.judge == '0'" src="../../../static/images/baihoc-den.png" class="curriculum_img" @click="goto_Aicourse(scope.row.courseId)"/>
                    <span>{{scope.row.courseName}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="traineeNum" :render-header="icons" min-width="80" :label="$t('scoreStatistics.studentsCounst')" header-align="center" align="center" width="160"></el-table-column>
                <el-table-column prop="examName" :render-header="icons" show-overflow-tooltip :label="$t('scoreStatistics.testName')" header-align="center" align="left" width="220">
                  <template slot-scope="scope">
                    <span>{{scope.row.examName}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="userScore" :render-header="icons" min-width="80" :label="$t('scoreStatistics.myScore')" header-align="center" align="center" width="160">
                  <template slot-scope="scope">
                    <el-button type="text" size="small">
                      <a @click="toScoreStatistics(scope.row.courseId,scope.row.courseName, )" style="cursor:pointer">{{scope.row.userScore}}</a>
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="avgScore" :render-header="icons" min-width="80" :label="$t('scoreStatistics.aveScore')" header-align="center" align="center" width="160"></el-table-column>
                <el-table-column prop="maxScore" :render-header="icons" min-width="80" :label="$t('scoreStatistics.maxPoint')" header-align="center" align="center" width="160"></el-table-column>
                <el-table-column prop="minScore" :render-header="icons" min-width="80" :label="$t('scoreStatistics.minPoint')" header-align="center" align="center" width="160"></el-table-column>
                <el-table-column prop="passPercents" min-width="80" :label="$t('scoreStatistics.passPercent')" header-align="center" align="center" width="180">
                  <template slot-scope="scope">
                    <span>{{Math.abs(scope.row.passPercent*scope.row.examTotalScore/100)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="judge" :render-header="icons" min-width="80" :label="$t('scoreStatistics.judge')" header-align="center" align="center" width="160">
                  <template slot-scope="scope">
                    <span v-if="scope.row.judge == '1'">{{$t('scoreStatistics.point90')}}</span>
                    <span v-if="scope.row.judge == '0'">{{$t('scoreStatistics.point80')}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="examHistory" :label="$t('courseProgress.examhistory')" class="cursor" header-align="center" align="center" width="180">
                  <template slot-scope="scope">
                    <el-button type="text" size="small">
                      <a @click="jumptoexamhistory(scope.row.courseId, scope.row.examId)" target="_blank">{{$t('courseProgress.look')}}</a>
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('scoreStatistics.point90')" header-align="center" align="center">
                  <el-table-column prop="passNum" :render-header="icons" min-width="60" :label="$t('scoreStatistics.personCount')" header-align="center" align="center" width="160"></el-table-column>
                  <el-table-column prop="passNumPercent" :render-header="icons" min-width="60" :label="$t('scoreStatistics.proportion')" header-align="center" align="center" width="160"></el-table-column>
                </el-table-column>
                <el-table-column :label="$t('scoreStatistics.point80')" header-align="center" align="center">
                  <el-table-column prop="noPassNum" :render-header="icons" min-width="60" :label="$t('scoreStatistics.personCount')" header-align="center" align="center" width="160"></el-table-column>
                  <el-table-column prop="noPassNumPercent" :render-header="icons" min-width="60" :label="$t('scoreStatistics.proportion')" header-align="center" align="center" width="160" ></el-table-column>
                </el-table-column>
              </el-table>
              <div :span="24" class="toolbar" style="text-align:center">
                <el-pagination @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize" layout="prev, pager, next" :total="this.datatablelist.length" background></el-pagination>
              </div>
            </div>
            <div v-if="!this.datatablelist.length > 0 && checkSearch == true" class="no-content">
              <img src="../../../static/images/noresult.jpg" alt />
              <p>{{ $t("search.result") }}</p>
            </div>
          </div>
          <!-- Table mobile -->
          <div class="course_box_mobile">
            <template v-for="(item, index) in mobiles">
              <template>
                <div class="box-1" @click="activeRow(item.id)" :key="index">
                  <div class="title_course_box" :class="{'turn-arrow': activeID == item.id}">
                    <div class="num_order">{{item.record}}</div>
                    <div class="title_course">
                      <img v-if="item.judge == $CONST.COMMON.NUMBER.ONE" src="../../../static/images/baihoc-xanhla.png" class="curriculum_img"/>
                      <img v-if="item.judge == $CONST.COMMON.NUMBER.ZERO" src="../../../static/images/baihoc-den.png" class="curriculum_img"/>
                      {{item.name}}
                    </div>
                  </div>
                  <div class="content_box" :class="{'active-content': activeID == item.id}">
                    <!-- List fields -->
                    <div class="content_new" v-for="(field, indexField) of itemsListMobile" :key="indexField">
                      <template v-for="(itemChild, indexChild) in item.listItems">
                        <div v-if="itemChild.name == field.name" :key="indexChild">
                          <template>
                            <h1 :key="indexField" v-if="itemChild.name != 'pass' && itemChild.name != 'failure'">{{field.label}}:</h1>
                            <template>
                              <a v-if="itemChild.name == 'examHistory'" class="nqt--examhistory" @click="jumptoexamhistory(item.id, item.examId)" target="_blank">{{$t('courseProgress.look')}}</a>
                              <a v-else-if="itemChild.name == 'userScore'" class="nqt--userscore" @click="toScoreStatistics(item.id, item.name, item.examId)">{{itemChild.value}}</a>
                              <span v-else-if="itemChild.name == 'passPercents'" class="nqt--examTotalScore">{{Math.abs(itemChild.value * item.examTotalScore / $CONST.COMMON.NUMBER.ONE_HUNDRED)}}</span>
                              <template v-else-if="itemChild.name == 'judge'">
                                <span v-if="itemChild.value == $CONST.COMMON.NUMBER.ONE">{{$t('scoreStatistics.point90')}}</span>
                                <span v-if="itemChild.value == $CONST.COMMON.NUMBER.ZERO">{{$t('scoreStatistics.point80')}}</span>
                              </template>
                              <!-- Đậu -->
                              <template v-else-if="itemChild.name == 'pass'">
                                <h1 class="nqt--pass-h1">{{field.label}}</h1>
                                <div class="nqt--pass" v-for="(itemChildd, indexChildd) in itemChild.list" :key="indexChildd">
                                  <template>
                                    <h1 v-if="itemChildd.name == 'passNum'">{{$t('scoreStatistics.personCount')}}:</h1>
                                    <h1 v-else>{{$t('scoreStatistics.proportion')}}:</h1>
                                  </template>
                                  <span>{{itemChildd.value}}</span>
                                </div>
                              </template>
                              <!-- Không đậu -->
                              <template v-else-if="itemChild.name == 'failure'">
                                <h1 class="nqt--pass-h1">{{field.label}}</h1>
                                <div class="nqt--pass" v-for="(itemChildd, indexChildd) in itemChild.list" :key="indexChildd">
                                  <template>
                                    <h1 v-if="itemChildd.name == 'noPassNum'">{{$t('scoreStatistics.personCount')}}:</h1>
                                    <h1 v-else>{{$t('scoreStatistics.proportion')}}:</h1>
                                  </template>
                                  <span>{{itemChildd.value}}</span>
                                </div>
                              </template>
                              <span v-else class="nqt--default">{{itemChild.value}}</span>
                            </template>
                          </template>
                        </div>
                      </template>
                    </div>
                    <!-- button -->
                    <div class="btn-course" @click="goto_Aicourse(item.id)">
                      <span>{{$t('manage_lesson.next_page_details')}}</span>
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </div>
          <!-- <el-pagination @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize" layout="prev, pager, next" :total="this.mobiles.length" background></el-pagination> -->
        </div>
        
        <!-- Loading -->
        <loading :showLoading="loading" />
    </div>

</template>

<script>
import Vue from "vue";
import { mapMutations } from "vuex";
import { lang } from "../../assets/languages/getLanguageType.js";
Vue.prototype.$lang = lang;
import en from "element-ui/lib/locale/lang/en";
import ja from "element-ui/lib/locale/lang/ja";
import vi from "element-ui/lib/locale/lang/vi";
import zh from "element-ui/lib/locale/lang/zh-CN";
import picker from "../../../node_modules/element-ui/lib/locale/index";
import loading from "@/components/loading/loading";

export default {
  name: "course_score_statistics",
  components: {
      loading,
  },
  data() {
    return {
      startDate: {
        disabledDate: (time) => {
          if (this.form.createEndTime) {
            return time.getTime() > new Date(this.form.createEndTime).getTime();
          }
        },
      },
      endDate: {
        disabledDate: (time) => {
          if (this.form.createBeginTime) {
            return (
              time.getTime() <
              new Date(this.form.createEndTime).getTime() - 20 * 3600 * 1000
            );
          } else {
            return time.getTime() < Date.now();
          }
        },
      },
      form: {
        courseName: "",
        createBeginTime: "",
        createEndTime: "",
        templateType: "",
        templateStatus: "",
        title: "",
        source: "",
        startDate: "",
        endDate: "",
        userName: "",
      },
      resultFlag: false, //结果标志
      pageNum: 1, //当前页码
      pageSize: 10, //每页数量
      totalPage: 0, //总页数
      searchResultList: [], //搜索结果
      total: 14,
      page: 1,
      limit: 10,
      item: null,
      userId: null, //用户id
      courseId: null,
      courseName: null, //课程id
      datatablelist: [],
      itemsMobile: ['avgScore', 'pass', 'failure', 'commonId', 'companyId', 'examHistory', 'courseEnd', 'courseId', 'courseName', 'courseStart', 'courseStartEnd', 'dateStart', 'dateStart2', 'examTotalScore', 'judge', 'maxScore', 'minScore', 'passPercent', 'passPercents', 'status', 'traineeNum', 'userScore', 'validityPeriodEnd', 'validityPeriodStart', 'examId', 'examName',],
      itemsListMobile: [
        {
          name: 'traineeNum',
          label: this.$t('scoreStatistics.studentsCounst')
        },
        {
          name: 'userScore',
          label: this.$t('scoreStatistics.myScore')
        },
        {
          name: 'avgScore',
          label: this.$t('scoreStatistics.aveScore')
        },
        {
          name: 'maxScore',
          label: this.$t('scoreStatistics.maxPoint')
        },
        {
          name: 'minScore',
          label: this.$t('scoreStatistics.minPoint')
        },
        {
          name: 'passPercents',
          label: this.$t('scoreStatistics.passPercent')
        },
        {
          name: 'judge',
          label: this.$t('scoreStatistics.judge')
        },
        {
          name: 'examHistory',
          label: this.$t('courseProgress.examhistory')
        },
        {
          name: 'pass',
          label: this.$t('scoreStatistics.point90')
        },
        {
          name: 'failure',
          label: this.$t('scoreStatistics.point80')
        },
        {
          name: 'examName',
          label: this.$t('scoreStatistics.testName')
        },
      ],
      mobiles: [],
      keyword: null,
      startOfValidity: null,
      endOfValidity: null,
      checked: false,
      checkSearch: false,
      checkListResponse: false,
      activeID: null,
      asc: true,
      listSort: [
        {
          colName: 'courseName',
          asc: true
        },
        {
          colName: 'traineeNum',
          asc: true
        },
        {
          colName: 'examName',
          asc: true
        },
        {
          colName: 'userScore',
          asc: true
        },
        {
          colName: 'avgScore',
          asc: true
        },
        {
          colName: 'maxScore',
          asc: true
        },
        {
          colName: 'minScore',
          asc: true
        },
        {
          colName: 'passPercents',
          asc: true
        }
        ,
        {
          colName: 'judge',
          asc: true
        },
        {
          colName: 'passNum',
          asc: true
        },
        {
          colName: 'passNumPercent',
          asc: true
        },
        {
          colName: 'noPassNum',
          asc: true
        },
        {
          colName: 'noPassNumPercent',
          asc: true
        }
      ],
      loading: true
    };
  },
  computed: {
    pagedDatatablelist() {
      return this.datatablelist.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page)
    }
  },
  mounted() {
    if (this.$lang() == "1") {
      picker.use(zh);
    } else if (this.$lang() == "2") {
      picker.use(en);
    } else if (this.$lang() == "3") {
      picker.use(ja);
    } else if (this.$lang() == "4") {
      picker.use(vi);
    } else {
      picker.use(en);
    }
    this.$autoLogin().then(
      () => {
        const that = this;
        //获取设备屏幕的高度
        const h = document.body.clientHeight - 50;
        // this.$refs.middle_page.style.minHeight = h + "px";
        //接收参数
        that.courseId = that.$route.query.courseId;
        //登录成功
        that.userId = window.sessionStorage.getItem("id");
        that.role = window.sessionStorage.getItem("role");
        //获取考试历史信息
        this.loading = true;
        that.$api
          .post("/home/getcourseScoreStatistics", {
            startOfValidity: that.startOfValidity,
            endOfValidity: that.endOfValidity,
            keyword: that.keyword,
            languageType: that.$lang(),
            // pageQuery: {
            //   pageNum: that.pageNum,
            //   pageSize: that.pageSize,
            // },
          })
          .then((response) => {
            if (response.meta.success == true) {
                this.loading = false
            }
            if (response.data.list.length > this.$CONST.COMMON.NUMBER.ZERO) {
              that.resultFlag = true;
              that.totalPage = response.data.total;
              that.searchResultList = that.convertData(response.data.list);
              that.datatablelist = that.sortedTables(response.data.list, 'userScore', this.asc);
              let data = response.data.list;
              data.forEach((item, i) => {
                if (item.examName==null||item.examName=="") {
                  item.examName = this.$t("scoreStatistics.finalExam");
                }
                let listItems = [];
                for (let index = this.$CONST.COMMON.NUMBER.ZERO; index < this.itemsMobile.length; index++) {
                  let name = this.itemsMobile[index];
                  let list = [];
                  if (name == 'pass') {
                    list.push({name: 'passNum', value: item['passNum']});
                    list.push({name: 'passNumPercent', value: item['passNumPercent']});
                  }
                  if (name == 'failure') {
                    list.push({name: 'noPassNum', value: item['noPassNum']});
                    list.push({name: 'noPassNumPercent', value: item['noPassNumPercent']});
                  }
                  if (name == 'passPercents') {
                    item[name] = item['passPercent'];
                  }
                  listItems.push({name: name, value: item[name], list: list});
                }
                this.mobiles.push({record: i + this.$CONST.COMMON.NUMBER.ONE,examTotalScore: item.examTotalScore, judge: item.judge, id: item.courseId, name: item.courseName, listItems: listItems});
              });
              this.checkListResponse = true;
            } else {
              that.totalPage = this.$CONST.COMMON.NUMBER.ZERO;
              that.datatablelist = [];
              that.resultFlag = false;
            }
          });
      },
      () => {
        //未登录跳回首页
        this.$router.push({
          path: "/home",
        });
        // this.$message.warning(window.vm.$i18n.t("read.login"));
      }
    );
  },
  methods: {
    tableHeaderStyle ({column, rowIndex, columnIndex}) {
      if(column.property != 'no' && columnIndex != 8 && columnIndex != 10 && columnIndex != 11 && columnIndex != 12) return 'cursor: pointer';
    },
    sortTable (column){
      if(column.property != undefined && column.property != 'no' && column.property != 'examHistory' && column.property != 'passPercents'){
        let key = this.listSort.findIndex((item) => item.colName == column.property);
        this.listSort[key].asc = !this.listSort[key].asc;
        this.datatablelist = this.sortedTables(this.datatablelist, column.property, this.listSort[key].asc);
      }
    },
    sortedTables (data, element, type) { 
      if (element == "courseName" || element == "examName") {
        return type ? data.sort((a, b) => a[element].localeCompare(b[element])) : data.sort((a, b) => b[element].localeCompare(a[element]));
      }
      return type ? data.sort((a, b) => parseFloat(a[element]) - parseFloat(b[element])) : data.sort((a, b) => parseFloat(b[element]) - parseFloat(a[element]));
    },
    activeRow: function (activeID) {
      if (this.activeID == activeID && this.activeID != null) {
        this.activeID =  null;
      } else {
        this.activeID = activeID;
      }
    },
    checkedCallBack(e, checkedFresh) {
      this.checked = !this.checked;
      this.search_s();
    },
    search: function () {
      this.loading = true;
      this.$api
        .post("/home/getcourseScoreStatistics", {
          startOfValidity: this.startOfValidity,
          endOfValidity: this.endOfValidity,
          keyword: this.keyword,
          languageType: this.$lang(),
          // pageQuery: {
          //   pageNum: this.pageNum,
          //   pageSize: this.pageSize,
          // },
          checked: this.checked,
        })
        .then((response) => {
          if (response.meta.success == true) {
              this.loading = false
          }
          this.mobiles = [];
          if (response.data.list.length > 0) {
            this.resultFlag = true;
            this.totalPage = response.data.total;
            this.searchResultList = this.convertData(response.data.list);
            this.datatablelist = this.sortedTables(response.data.list, 'userScore', this.asc);
            let data = response.data.lists;
              data.forEach((item, i) => {
                let listItems = [];
                for (let index = this.$CONST.COMMON.NUMBER.ZERO; index < this.itemsMobile.length; index++) {
                  let name = this.itemsMobile[index];
                  let list = [];
                  if (name == 'pass') {
                    list.push({name: 'passNum', value: item['passNum']});
                    list.push({name: 'passNumPercent', value: item['passNumPercent']});
                  }
                  if (name == 'failure') {
                    list.push({name: 'noPassNum', value: item['noPassNum']});
                    list.push({name: 'noPassNumPercent', value: item['noPassNumPercent']});
                  }
                  if (name == 'passPercents') {
                    item[name] = item['passPercent'];
                  }
                  listItems.push({name: name, value: item[name], list: list});
                }
                this.mobiles.push({record: i + this.$CONST.COMMON.NUMBER.ONE,examTotalScore: item.examTotalScore, judge: item.judge, id: item.courseId, name: item.courseName, listItems: listItems});
              });
              this.checkListResponse = true;
          } else {
            this.mobiles = [];
            this.totalPage = 0;
            this.datatablelist = [];
            this.resultFlag = false;
            this.checkSearch = true;
          }
        });
    },
    search_s: function () {
      this.pageNum = 1;
      this.page = 1;
      this.search();
    },
    startCalendarClick(val) {},
    endCalendarClick(val) {},
    GotestPage: function () {
      this.$router.push({
        path: "/home/testPage",
        query: {
          courseId: this.courseId,
          courseName: this.$route.query.courseName,
        },
      });
    },
    handleSizeChange(val) {
      this.page = val;
      this.pageNum = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.activeID = null;
      this.pageNum = val;
      // this.search();
    },
    toScoreStatistics: function (courseId, courseName, examId) {
      if (this.errorBookFlag == 0) {
        this.$message.warning(window.vm.$i18n.t("js.examDataNone"));
        return;
      }
      this.$router.push({
        path: "exam/scoreStatistics",
        query: {
          courseId: courseId,
          examId: examId,
          courseName: courseName,
          num: 1,
        },
      });
    },
    jumptoexamhistory: function (courseId, examId) {
      this.$router.push({
        path: "exam/examRecord",
        query: {
          courseId: courseId,
          examId: examId,
          examRecordReturnNum: 1,
        },
      });
    },
    ...mapMutations("header", ["setHistory"]),
    goto_Aicourse: function (courseId) {
      window.sessionStorage.setItem("courseGOBackNum", 6);
      this.setHistory("/home/courseScoreStatistics");
      this.$router.push({
        name: "Aicourse",
        query: {
          buyCourseId: courseId,
          buyCollegeId: JSON.stringify(1),
        },
      });
    },
    icons(h,{column}){
      return [
        h('span', column.label),
        h('i', {
          class: 'el-icon-d-caret',
          style: 'color:#ffffff;margin-left:3px;'
        })
      ]
    },
    convertData: function (data) {
      const results = data.reduce((accumulator, value) => {
          if ((value.examName == null || value.examName == "") && value.examId == null) {
              value.examName = this.$t("scoreStatistics.finalExam");
          }
          accumulator.push(value);
          return accumulator;
      }, []);

      return results;
    }
  },
};
</script>

<style scoped="scoped">
.page-bk-col {
  background-color: #ffffff;
}
.font_col {
  text-align: center;
  color: #fff;
}
.exam_page {
  width: 100%;
  background: url(/static/images/bg/personset_bg.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  position: relative;
  min-height: 100vh;
}

.exam_main {
  background-color: rgba(65, 65, 65, 0.5);
  width: 100%;
  height: 100%;
  padding-bottom: 50px;
  min-height: calc(100vh - 50px);
}

.examPage {
  width: 100%;
  margin: 0 auto;
  padding-top: 20px;
}

.examCenter_img {
  margin-top: 40px;
  width: 40%;
  margin-left: calc(20% - 30px);
  position: relative;
}

.examCenter_img img {
  height: 120px;
}

.examCenter_img p:first-child {
  font-size: 40px;
  color: #fafafa;
  font-family: marzo-w00-regular, fantasy;
  font-weight: 400;
}

.examCenter_img p:first-child span {
  font-size: 40px;
  color: #ff5252;
  font-family: braggadocio-w01, fantasy;
  font-weight: 400;
}

.examCenter_img p:nth-child(2) {
  font-size: 45px;
  color: #e8e6e6;
  font-family: roboto-thin, roboto, sans-serif;
  font-weight: 400;
}

.exam_begins_box {
  width: 95%;
  padding-top: 30px;
  padding-bottom: 0px;
  padding-left: 30px;
  padding-right: 30px;
  border-radius: 15px;
  margin: 0 auto;
  margin-top: 80px;
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.1);
  position: relative;
}

.course_box {
  width: 100%;
  border-radius: 15px;
  /* background-color: rgba(0, 0, 0, 0.3); */
  /* box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3); */
  position: relative;
  margin-bottom: 20px;
}

.exam_page_span {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

.examination_notes {
  height: 20px;
  font-size: 20px;
  color: #e8e6e6;
  text-align: center;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_begins_box .exam_begins_rule {
  position: relative;
  /* display: -webkit-flex; */
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px #414141 solid;
}

.exam_begins_rule .exam_begins_rule_title {
  width: auto;
  height: 20px;
  margin-right: 10px;
  font-size: 14px;
  color: #e8e6e6;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_begins_rule .exam_begins_rule_content {
  width: 520px;
  min-height: 20px;
  position: relative;
  display: block;
}

.exam_begins_rule .exam_begins_rule_content p {
  min-height: 20px;
  line-height: 20px;
  display: flex;
  font-size: 14px;
  color: #e8e6e6;
  text-align: left;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_notes {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #e8e6e6;
  text-align: center;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_notes:first-child {
  margin-top: 40px;
}

.exam_btn {
  margin: 0 auto;
  margin-top: 3px;
  display: block;
  text-align: center;
  font-size: 16px;
  color: #fff;
  padding: 6px 20px;
  border-radius: 20px;
  transition: 0.5s ease;
  border: 1px solid #00d3ff;
  background-image: -webkit-linear-gradient(315deg, #00d3ff 0%, #02adff 100%);
  background-image: linear-gradient(135deg, #00d3ff 0%, #02adff 100%);
}

.exam_btn:hover {
  color: #000;
  background-color: #fff;
  transition: 0.5s ease;
}
.item {
  margin-top: 0px;
  margin-right: 0px;
  margin-left: 0px;
}

.has-gutter tr td {
  background: #f30;
}
.el-table >>> .has-gutter tr th {
  background-image: -webkit-linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
  background-image: linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
}
.el-table >>> .el-table__header thead tr th {
  background-image: -webkit-linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
  background-image: linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
}
.el-table >>> .cell .el-button span {
  background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  color: #fff;
  padding: 3px 8px;
  border-radius: 15px;
  -webkit-transition: 0.5s ease;
  transition: 0.5s ease;
}
.el-table >>> .cell .el-button span:hover {
  color: #333;
}

.toolbar >>> .el-pagination {
  margin-top: 8px;
}
.toolbar >>> .el-pagination .btn-next,
.toolbar >>> .el-pagination .btn-prev {
  border-radius: 5px;
  background: unset;
  color: #fff;
}
.toolbar >>> .el-pager li {
  min-width: unset;
  margin: 0 5px;
}
.curriculum_img {
  cursor: pointer;
  width: 20px;
  height: 20px;
  margin-top: -3px;
  margin-right: 3px;
  display: inline-block;
  vertical-align: middle;
}
@media screen and (max-width: 1024px) {
  .examPage {
    width: calc(100% - 60px);
  }
  .exam_begins_box {
    width: 94%;
    min-width: 500px;
    padding: 3%;
  }
  .form-item {
    margin-left: 0px;
  }
  .el-col-7,
  .el-col-6 {
    text-align: left;
    min-width: 100px;
    width: unset;
  }
}
/* switch */
  .menu-switch-school {
    display: block;
    position: relative;
    width: 46px;
    height: 27px;
    border: 1px solid #dfdfdf;
    outline: 0;
    border-radius: 16px;
    box-sizing: border-box;
    background-color: #dfdfdf;
    transition: background-color 0.1s, border 0.1s;
    cursor: pointer;
  }
  .menu-switch-school:before {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    width: 44px;
    height: 25px;
    border-radius: 15px;
    transition: transform 0.35s cubic-bezier(0.45, 1, 0.4, 1);
  }
  .menu-switch-school:after {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    width: 24px;
    height: 24px;
    border-radius: 15px;
    background-color: #ffffff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
    transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
  }
  .menu-switch-school-on {
    border-color: #79c9ff;
    background-color: #79c9ff;
  }
  .lesson_begin.menu-switch-school-on:before {
    border-color: #79c9ff;
    background-color: #79c9ff;
  }
  .lesson_learning.menu-switch-school-on:before {
    border-color: #da251d;
    background-color: #da251d;
  }
  .lesson_end.menu-switch-school-on:before {
    border-color: #118e07;
    background-color: #118e07;
  }
  .menu-switch-school-on:after {
    transform: translateX(20px);
  }
  .lesson_begin.menu-switch-school-on:before {
    border-color: #79c9ff;
    background-color: #79c9ff;
  }
  .showCompletedCourseCheck {
    display: flex;
  }
  .showCompletedCourseCheckText {
    color: rgb(0, 0, 0);
    margin-left: 7px;
    margin-top: -6px;
  }
</style>



// WEBPACK FOOTER //
// src/views/courseScoreStatistics/scoreStatistics.vue